import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AvatarComponent } from '../avatar/avatar.component';

@Component({
  selector: 'ui-user',
  standalone: true,
  imports: [CommonModule, AvatarComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      .user-root {
        display: inline-flex;
        align-items: center;
        gap: 0.75rem; /* 12px */
        text-decoration: none;
        color: inherit;
      }

      .user-root.horizontal {
        flex-direction: row;
      }
      .user-root.vertical {
        flex-direction: column;
        text-align: center;
      }
      .user-root.vertical {
        gap: 0.5rem; /* 8px */
      }

      .user-root.is-link {
        cursor: pointer;
      }

      .chip-wrapper {
        position: relative;
      }
      .chip-wrapper::after {
        content: '';
        position: absolute;
        bottom: 0;
        right: 0;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #16a34a; /* Green dot */
        border: 2px solid white;
      }

      .text-wrapper {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        min-width: 0; /* Prevents text overflow */
      }

      .name {
        font-weight: 500;
        color: #111827; /* Dark text */
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .name-sm {
        font-size: 0.875rem; /* 14px */
      }
      .name-md {
        font-size: 1rem; /* 16px */
      }
      .name-lg {
        font-size: 1.125rem; /* 18px */
      }

      .user-root.is-link:hover .name {
        text-decoration: underline;
      }

      .description {
        color: #6b7280; /* Muted color */
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .description-sm {
        font-size: 0.75rem; /* 12px */
      }
      .description-md {
        font-size: 0.875rem; /* 14px */
      }
      .description-lg {
        font-size: 1rem; /* 16px */
      }
    `,
  ],
  template: `
    @if (href(); as link) {
      <a [href]="link" class="user-root is-link" [class.horizontal]="orientation() === 'horizontal'" [class.vertical]="orientation() === 'vertical'">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </a>
    } @else {
      <div class="user-root" [class.horizontal]="orientation() === 'horizontal'" [class.vertical]="orientation() === 'vertical'">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </div>
    }

    <ng-template #content>
      @if (imageUrl()) {
        @if (chip()) {
          <div class="chip-wrapper">
            <ui-avatar [imageUrl]="imageUrl()" [altText]="name()" [size]="size()" />
          </div>
        } @else {
          <ui-avatar [imageUrl]="imageUrl()" [altText]="name()" [size]="size()" />
        }
      }

      <div class="text-wrapper">
        @if (name()) {
          <span class="name capitalize" [class.name-sm]="size() === 'sm'" [class.name-md]="size() === 'md'" [class.name-lg]="size() === 'lg'">
            {{ name() }}
          </span>
        }
        @if (description()) {
          <span class="description" [class.description-sm]="size() === 'sm'" [class.description-md]="size() === 'md'" [class.description-lg]="size() === 'lg'">
            {{ description() }}
          </span>
        }
      </div>
    </ng-template>
  `,
})
export class UserComponent {
  name = input<string>('');
  imageUrl = input<string>('');

  description = input<string>('');
  size = input<'sm' | 'md' | 'lg'>('md');
  orientation = input<'horizontal' | 'vertical'>('horizontal');
  href = input<string>('');
  chip = input<boolean>(false);
}
